export default __webpack_public_path__ + "static/media/ri2.f6b224cf.png";